<template>
    <div>
        <label class="order__input-label">Комментарии к заказу</label>
        <textarea v-model="comment" v-on:change="onChange()" name="user_info" cols="80" rows="4"></textarea>
    </div>
</template>

<script>
    export default {
        name: "delivery-comment",
        props: ['user_info'],
        data () {
            return {
                comment: this.user_info
            }
        },
        methods: {
            onChange () {
                this.$store.dispatch('setUserInfo', this.comment)
            }
        }
    }
</script>

<style scoped>

</style>